(function () {
    'use strict';

    angular
        .module('ib-new-seat-map-module')
        .directive('ibOverflowCheck', ibOverflowCheck);

    ibOverflowCheck.$inject = ['$window', '$timeout'];
    function ibOverflowCheck ($window, $timeout) {
        return {
            restrict: 'A',
            link: link
        };

        function link (scope, element) {
            setTimeout(
                () => {
                    const overflowDiv: any = document.getElementById('passengersMobile');
                    // Only check width overflow
                    if(overflowDiv.scrollWidth > overflowDiv.clientWidth) {
                        overflowDiv.classList.remove('ib-new-map-seats__passengers-center');
                    } else {
                        overflowDiv.classList.add('ib-new-map-seats__passengers-center');
                    }
                }
                , 10);
        }
    }
})();